import { render, staticRenderFns } from "./CompaniesPilver.vue?vue&type=template&id=0e9a3457&"
import script from "./CompaniesPilver.vue?vue&type=script&lang=js&"
export * from "./CompaniesPilver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports